import {
  localStorageLang,
  FEED_URLSRC_CMS_V2,
  CMS_PROGROW_TYPE_CATEGORY,
  CMS_PROGROW_TYPE_BOXSET,
  CMS_PROGROW_TYPE_PROGRAMMESET,
} from "../constants";
import {
  FETCH_CATEGORIES_HAS_ERRORED,
  FETCH_CATEGORIES_IS_LOADING,
  FETCH_CATEGORIES,
  CAT_HAS_ERRORED,
  CAT_IS_LOADING,
  CAT_FETCH_DATA_SUCCESS,
  CAT_PROG_ROWS_FETCH_DATA_SUCCESS,
  CAT_PROG_ROWS_HAS_ERRORED,
  CAT_PROG_ROWS_IS_LOADING,
} from "./types";
import { globalFetch } from "./globalActions";
import {
  decodeHtml,
  programmeTitle,
  programmeRowName,
  isCmsImage,
} from "../helpers";

///////////
// Categories //
///////////

//Get list of Categories
export function fetchCategories() {
  return globalFetch({
    urlPath: `category_list_feed`,
    reducerIsLoading: FETCH_CATEGORIES_IS_LOADING,
    reducerError: FETCH_CATEGORIES_HAS_ERRORED,
    dispatchSuccess: (itemObj, dispatch) => {
      dispatch(fetchCatSuccess(itemObj));
    },
  });
}

export function fetchCatSuccess(items) {
  const lang =
    localStorage.getItem(localStorageLang) === null
      ? 0
      : parseInt(localStorage.getItem(localStorageLang), 10);

  const textWw = lang === 0 ? "Byd-eang" : "Worldwide";
  const idsAvailablity = ["99"],
    idsAccessability = ["100"],
    idsKids = ["13"],
    idsTeens = ["16"];
  let dataObj,
    arrayCategories = [],
    arrayKids = [],
    arrayTeens = [],
    arrayAccessabilit = [];

  if (Object.keys(items.categories).length > 0) {
    for (var key in items.categories) {
      if (
        !idsAvailablity.includes(items.categories[key].id) &&
        !idsAccessability.includes(items.categories[key].id)
      ) {
        arrayCategories[key] = items.categories[key];
      }

      if (idsKids.includes(items.categories[key].id)) {
        arrayKids[key] = items.categories[key];
      }

      if (idsTeens.includes(items.categories[key].id)) {
        arrayTeens[key] = items.categories[key];
      }

      if (idsAccessability.includes(items.categories[key].id)) {
        arrayAccessabilit[key] = items.categories[key];
      }
    }

    dataObj = {
      no_ads: "0",
      categories: arrayCategories,
      kids: arrayKids,
      teens: arrayTeens,
      accessibility: arrayAccessabilit,
      availability: [
        {
          id: "99",
          genre: textWw,
        },
      ],
    };
  }

  return {
    type: FETCH_CATEGORIES,
    payload: dataObj,
  };
}

//Get list of programmes in Category
export function catFetchData(id) {
  return globalFetch({
    urlPath: `programme_feed_by_category`,
    extraParams: `&id=${id}`,
    reducerIsLoading: CAT_IS_LOADING,
    reducerError: CAT_HAS_ERRORED,
    dispatchSuccess: (itemObj, dispatch) => {
      dispatch(catFetchDataSuccess(itemObj));
    },
  });
}

export function catFetchDataSuccess(items) {
  let cardItems = [];
  if (items.progs.length > 0) {
    let id,
      series_id,
      title,
      subTitle,
      short_billing,
      thumbnail = "default.jpg",
      isActions = true,
      isProgress = false,
      cardClass = "card--small",
      progress = false,
      count = false;

    Object.entries(items.progs).forEach(([key, value]) => {
      id = value.id;
      series_id = value.series_id;
      title = value.series_title;
      subTitle = value.programme_title;

      if (!title) {
        title = subTitle;
        subTitle = value.clic_aired;
      }
      if (!subTitle) {
        subTitle = value.clic_aired;
      }

      thumbnail = value.thumbnail_url;
      short_billing = value.short_billing;
      count = value.count;
      cardItems[key] = {
        id,
        series_id,
        title,
        subTitle,
        short_billing,
        thumbnail,
        isActions,
        isProgress,
        progress,
        cardClass,
        count,
      };
    });
  }

  return {
    type: CAT_FETCH_DATA_SUCCESS,
    payload: cardItems,
  };
}

//New Programme Rows Fetching
export function catProgRowsFetchData(id) {
  return globalFetch({
    urlPath: "sections/category",
    extraParams: parseInt(id, 10) === 0 ? "" : id,
    urlSrc: FEED_URLSRC_CMS_V2,
    reducerIsLoading: CAT_PROG_ROWS_IS_LOADING,
    reducerError: CAT_PROG_ROWS_HAS_ERRORED,
    dispatchSuccess: (itemObj, dispatch) => {
      dispatch(catProgRowsDataSuccess(itemObj));
    },
  });
}

export function catProgRowsDataSuccess(items) {
  //Format the Hero cards
  let heroItems = [];
  if (items.result.heroCards && items.result.heroCards.length > 0) {
    Object.entries(items.result.heroCards).forEach(([key, value]) => {
      heroItems[key] = {
        id: key,
        title: decodeHtml(value.title),
        content: decodeHtml(value.description),
        subheading: decodeHtml(value.preTitle),
        primary_media: value.image && value.image.path ? value.image.path : "",
        primary_media_portrait: value.portraitImage && value.portraitImage.path ? value.portraitImage.path : "",
        entered_url: value.internalPath
          ? value.internalPath
          : value.externalUrl,
        subheading_icon: value.buttonText,
        buttonText: value.buttonText,
      };
    });
    items.result.heroCards = heroItems;
  }
  //Format the programme rows cards
  let progItems = [],
    progTitles = {};
  if (items.result.programmeRows && items.result.programmeRows.length > 0) {
    Object.entries(items.result.programmeRows).forEach(([key, value]) => {
      progItems = [];
      progTitles = {};
      if (value.type === CMS_PROGROW_TYPE_CATEGORY) {
        value.category.programmes &&
          Object.entries(value.category.programmes).forEach(
            ([cardKey, cardValue]) => {
              progTitles = programmeTitle(
                cardValue.seriesTitle,
                cardValue.programmeTitle,
                cardValue.clic_aired
              );
              progItems[cardKey] = {
                id: cardValue.programmeId,
                title: progTitles.title,
                billing: decodeHtml(cardValue.shortBilling),
                subTitle: progTitles.subTitle,
                thumbnail:
                  cardValue.image && cardValue.image.path
                    ? cardValue.image.path
                    : "",
                isCMSThumbnail: isCmsImage(cardValue.image.url),
                isActions: true,
              };
            }
          );
      } else if (value.type === CMS_PROGROW_TYPE_BOXSET) {
        value.boxSet.cards &&
          Object.entries(value.boxSet.cards).forEach(([cardKey, cardValue]) => {
            progItems[cardKey] = {
              id: cardValue.programmeId,
              title: decodeHtml(cardValue.preTitle),
              billing: decodeHtml(cardValue.description),
              subTitle:
                cardValue.title && cardValue.title.length > 0
                  ? decodeHtml(cardValue.title)
                  : cardValue.clic_aired,
              thumbnail:
                cardValue.image && cardValue.image.path
                  ? cardValue.image.path
                  : "",
              isCMSThumbnail: isCmsImage(cardValue.image.url),
              isActions: true,
              count: cardValue.count,
            };
          });
      } else if (value.type === CMS_PROGROW_TYPE_PROGRAMMESET) {
        value.programmeSet.programmeCards &&
          Object.entries(value.programmeSet.programmeCards).forEach(
            ([cardKey, cardValue]) => {
              progItems[cardKey] = {
                id: cardValue.programmeId,
                title: decodeHtml(cardValue.preTitle),
                billing: decodeHtml(cardValue.description),
                subTitle:
                  cardValue.title && cardValue.title.length > 0
                    ? decodeHtml(cardValue.title)
                    : cardValue.programme.clic_aired,
                thumbnail:
                  cardValue.image && cardValue.image.path
                    ? cardValue.image.path
                    : "",
                isCMSThumbnail: isCmsImage(cardValue.image.url),
                isActions: true,
              };
            }
          );
      }
      items.result.programmeRows[key].cards = progItems;
      items.result.programmeRows[key].title = programmeRowName(value);
    });
  }

  return {
    type: CAT_PROG_ROWS_FETCH_DATA_SUCCESS,
    payload: items.result,
  };
}
